<template lang="pug">
	.creative-version-create-editable-playable(v-if="showed" v-window)
		.card(@click.stop="unselect()")
			.card-header
				span Create new AI playable
			.card-body.collapse.show
				.editable-playables.separator(:span="8")
					.editable-playable-container(v-for="template in templates" :class="{selected: template === selectedTemplate}" @click.stop="select(template)")
						.preview(:style="{backgroundImage: `url(/Images/Icons/Playables/${template.codename}.png)`}")
						span.title {{template.title}}
						span.description.text-muted(v-if="template.description") {{template.description}}
					.no-templates.text-muted(v-if="templates.length === 0") There are no templates yet
			.card-body.collapse.show(@click.stop)
				.form-horizontal
					.form-actions
						button.btn.btn-primary(v-if="selectedTemplate" type="submit" v-on:click="createFromTemplate()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create from template
						button.btn.btn-primary(v-if="!selectedTemplate" type="submit" v-on:click="createFromScratch()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create from scratch
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Creative } 			from "@/services/Creative";

	export default {
		name: "EditablePlayableCreateVersion",
		mixins: [Screen],
		screen: {
			updateOn: ["Metadata Loaded"],
			events: {
				"Show EditablePlayableCreateVersion": function() {

					this.selectedTemplate = null;

				},
				"Metadata Loaded": function() {

					this.selectedTemplate = null;

				}
			}
		},
		data() {

			return {
				showed: false,
				selectedTemplate: null,
				templates: []
			};

		},
		methods: {
			collectData() {

				// Шаблонов для редактируемых плейаблов пока нет, список может быть пустым
				this.templates = _.filter(Metadata.Templates, template => template.type === 'editable-playable' && template.active === 1 && (!template['publisher_id'] || template['publisher_id'] === Publisher.SelectedPublisher['id']));

			},
			select(template) {

				this.selectedTemplate = template;

			},
			unselect() {

				this.selectedTemplate = null;

			},
			createFromTemplate() {

				if (!this.selectedTemplate) return;

				Server.sendToSocket({
					CreateEditablePlayableFromTemplate: {
						creativeId: Creative.SelectedCreative.id,
						templateCodename: this.selectedTemplate.codename
					}
				});

				this.hide();

			},
			createFromScratch() {

				Server.sendToSocket({
					CreateEditablePlayableFromScratch: {
						creativeId: Creative.SelectedCreative.id
					}
				});

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-version-create-editable-playable
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 850px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: transform 0.2s

			.editable-playables
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				height: 360px
				overflow-y: auto

				.no-templates
					padding: 40px 0

				.editable-playable-container
					display: flex
					flex-direction: column
					align-items: center
					width: 250px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41
					overflow: hidden

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 248px
						height: 140px
						margin: 10px
						margin-top: 0
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title
						margin-bottom: 10px

					.description
						font-size: 12px
						line-height: 14px
						padding: 0 10px
						margin-top: -6px
						margin-bottom: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

				button.btn-primary
					margin-right: 20px

</style>
